import React, { useState, useEffect } from 'react';

const SignalIndicator: React.FC = () => {
    const [signalLevel, setSignalLevel] = useState<number>(0);
    const [isConnecting, setIsConnecting] = useState<boolean>(false);
    const [lastPing, setLastPing] = useState<number | null>(null);

    const pingServer = async (): Promise<void> => {
        const start = performance.now();
        setIsConnecting(true);

        try {
            await fetch(import.meta.env.VITE_API_URL + '/ping', { cache: "no-store" });
            const rtt = performance.now() - start;
            setLastPing(rtt);
            updateSignalLevel(rtt);
        } catch (err) {
            setSignalLevel(0);
            setLastPing(null);
        } finally {
            setIsConnecting(false);
        }
    };

    const updateSignalLevel = (rtt: number): void => {
        if (rtt < 200) setSignalLevel(3);
        else if (rtt < 600) setSignalLevel(2);
        else setSignalLevel(1);
    };

    useEffect(() => {
        // Initial ping
        pingServer();

        // Set up interval
        const interval = setInterval(pingServer, 5000);

        return () => clearInterval(interval);
    }, []);

    const getSignalColor = (level: number): string => {
        if (level === 0) return 'bg-gray-300 dark:bg-[#404040]';
        if (level <= 1) return 'bg-red-500';
        if (level <= 2) return 'bg-yellow-500';
        return 'bg-green-500';
    };

    // const getStatusText = (): string => {
    //     if (isConnecting) return 'Connecting...';
    //     if (signalLevel === 0) return 'Disconnected';
    //     if (signalLevel <= 2) return 'Poor';
    //     if (signalLevel <= 3) return 'Fair';
    //     return 'Excellent';
    // };

    return (
        <div className="flex flex-col items-center justify-center space-y-2 w-12 h-14 bg-white dark:bg-[#252526] rounded-lg shadow-sm border">


            {/* Signal bars */}
            <div className="flex items-end space-x-1 mt-1">
                {[1, 2, 3].map((bar) => (
                    <div
                        key={bar}
                        className={`w-1 transition-all duration-300 ${bar <= signalLevel
                            ? getSignalColor(signalLevel)
                            : 'bg-gray-200 dark:bg-[#333333]'
                            } ${bar === 1 ? 'h-2' :
                                bar === 2 ? 'h-3' :
                                    bar === 3 ? 'h-4' :
                                        bar === 4 ? 'h-5' : 'h-6'
                            }`}
                    />
                ))}
            </div>

            {/* Status text */}
            <div className="flex flex-col items-center text-xs">
                {/* <span className={`font-medium ${signalLevel === 0 ? 'text-gray-500' :
                    signalLevel <= 2 ? 'text-red-600' :
                        signalLevel <= 3 ? 'text-yellow-600' :
                            'text-green-600'
                    }`}>
                    {getStatusText()}
                </span> */}

                <span className="text-gray-400 dark:text-[#858585]">
                    {!lastPing || isConnecting ? '-' : Math.round(lastPing)}ms
                </span>
            </div>

            {/* Loading indicator */}
            {/* {isConnecting && (
                <div className="w-3 h-3 border border-blue-500 border-t-transparent rounded-full animate-spin" />
            )} */}
        </div>
    );
};

export default SignalIndicator;
